export const flatten = (result, arr) => [...result, ...arr];
